import { toast } from 'react-toastify';
import appApi from '../../../../../../../../../api/app-api';
import { ExamSessionDetails } from '../../../../../../../../../api/types/programs/course/exams/response/exam-metadata';

export const updateNotesCollectedOperation = async (
  currentProgramId: number | undefined,
  currentCourseId: number | undefined,
  examId: number,
  examSessionId: number | undefined,
  collectedNotes: boolean,
  setSessionDetails: (sessions: ExamSessionDetails[]) => any,
) => {
  try {
    if (!currentProgramId || !currentCourseId || !examSessionId) {
      toast.warn('לא ניתן לאתר את מזהה התוכנית ו/או הקורס');
      return;
    }

    const res = await appApi.updateSessionNotesCollected(
      currentProgramId,
      currentCourseId,
      examId,
      examSessionId,
      collectedNotes,
    );

    setSessionDetails(res.data.body);

    // TODO api call
  } catch (e) {}
};
